import { Quote, Star } from "lucide-react";
import { motion } from "framer-motion";

const ITEMS = [
  {
    name: "Priya Patil",
    role: "Boutique Owner",
    text: "Velora Web created a beautiful and professional website for my business. The team was responsive, creative, and delivered everything on time.",
  },
  {
    name: "Rohit Deshmukh",
    role: "Startup Founder",
    text: "Our new website looks modern and works perfectly on all devices. Velora Web exceeded my expectations with their quality and support.",
  },
  {
    name: "Amit Shinde",
    role: "Restaurant Owner",
    text: "The team understood my requirements and built a fast, responsive website. I highly recommend Velora Web to anyone looking for professional web services.",
  },
  {
    name: "Neha Gupta",
    role: "Marketing Lead",
    text: "Velora Web completely transformed our online presence and helped us attract clients from outside our city. Our website now generates leads consistently and has become a key part of our business growth.",
  },
];

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 lg:py-28 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-14">
          <div className="text-xs sm:text-sm tracking-[0.4em] text-[rgb(182,245,0)] font-mono-alt uppercase mb-4">
            Kind Words
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white">
            What Clients <span className="text-[rgb(182,245,0)]">Say</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {ITEMS.map((t, i) => (
            <motion.div
              key={t.name}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="surface rounded-2xl p-7 relative"
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-[rgba(182,245,0,0.25)]" />
              <div className="flex gap-1 mb-5">
                {[...Array(5)].map((_, j) => (
                  <Star
                    key={j}
                    className="w-4 h-4 fill-[rgb(182,245,0)] text-[rgb(182,245,0)]"
                  />
                ))}
              </div>
              <p className="text-white/80 leading-relaxed mb-6">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3 pt-5 border-t border-white/5">
                <div className="w-11 h-11 rounded-full bg-[rgb(182,245,0)] text-black font-display font-bold flex items-center justify-center">
                  {t.name
                    .split(" ")
                    .map((n) => n[0])
                    .join("")}
                </div>
                <div>
                  <div className="font-semibold text-white">{t.name}</div>
                  <div className="text-xs text-white/50">{t.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
